const MainHeader = {
  textStyle: {
    textAlign: 'center',
    fontFamily: 'Kalameh',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#707070',
  },

};

export default MainHeader;